import axios from "../axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../slices/userSlice";
import { resetDashboardState } from "../slices/k8/dashboardSlice";
import Button from "../collections/shared/Button/Button";
import Tooltip from "../collections/shared/Tooltip/Tooltip";

function LoginRegisterScreen() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isApiCall, setIsApiCall] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const { access_token } = useSelector((state) => state.user);

  useEffect(() => {
    // if (userData) {
    access_token && navigate("/collections");
    // }
  }, [access_token]);

  useEffect(() => {
    setTimeout(() => {
      toast.dismiss();
    }, 3000);

    return () => {};
  }, []);

  const submitLoginForm = (e) => {
    e.preventDefault();
    const [email, password] = ["email", "password"].map(
      (key) => e.target[key].value
    );
    setIsApiCall(true);

    axios
      .post(
        "/auth/login",
        {
          email,
          password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        let {
          data: { data: userData },
        } = res;

        if (userData.deleted) {
          toast.error("You are not allowed to login");
          return;
        }
        let obj = {
          id: userData._id,
          name: userData.name,
          email: userData.email,
          collections: userData.collections,
        };

        dispatch(resetDashboardState());
        dispatch(
          login({
            user: obj,
            access_token: userData.access_token,
            has_name: userData.profileCompletion.name,
            is_authenticated: true,
          })
        );

        setIsApiCall(false);

        navigate("/collections");
      })
      .catch((err) => {
        setIsApiCall(false);
        let data = err.response?.data;
        if (!data?.success) {
          toast.error("Error: " + (data?.error?.message || "Something went wrong"));
        }
      });
  };

  const handleGoogleAuthentication = () => {
    dispatch(
      login({
        is_authenticated: true,
      })
    );
    let timer = null;
    const googleLoginUrl = `${process.env.REACT_APP_API_BASE_URL}/auth/login/sso/google`;
    const newWindow = window.open(
      googleLoginUrl,
      "_self",
      "width=500,height=600"
    );

    if (newWindow) {
      window.addEventListener("message", (event) => {
        if (
          event.origin === process.env.REACT_APP_API_BASE_URL
        ) {
          if (event.data && event.data.type === "authenticationSuccess") {
            clearInterval(timer);
            newWindow.close();
          }
        }
      });
    }
  };

  return (
    <div className="grid grid-cols-2 gap-10 w-full place-items-center h-[calc(100vh-75px)] absolute top-[75px]">
      <div className="col-span-1 md:visible hidden w-full md:h-full md:flex justify-center items-center bg-[#efefef] shadow-lg">
        <img
          className="w-full md:w-[75%] h-full md:object-contain object-cover"
          src="/Images/loginImage.svg"
          alt=""
        />
      </div>
      <div className="col-span-2 md:col-span-1 w-full h-full items-center justify-center flex">
        <div className="  flex flex-col w-[85%] md:w-[75%] lg:w-[70%]  gap-5">
          {/* Avatar */}
          <div className="flex justify-center  flex-col mb-2 gap-1">
            <h2 className="text-3xl md:text-4xl">
              Welcome Back!
              <span className="wave text-4xl md:text-5xl">👋</span>
            </h2>
            <p className="text-gray-500 font-normal text-sm ml-1">
              Login to your account
            </p>
            {/* <i className="border-[#dedbf6] p-1 border-4 rounded-full fa-solid fa-circle-user text-6xl text-primary"></i> */}
          </div>

          {/* Form */}
          <form onSubmit={submitLoginForm}>
            <div className="flex flex-col w-full gap-4">
              <div className="flex flex-col gap-2">
                <label className="">Email ID</label>
                <input
                  name="email"
                  required
                  data-testid="userIdInput"
                  className="bg-[#f8f8f8] font-normal border-[2.6px] border-[#efefef] placeholder:text-[#b4b4b4] placeholder:font-normal focus:!ring-primary px-3.5 py-3 rounded-md"
                  type="email"
                  placeholder="Enter your email"
                />
              </div>

              <div className="relative flex flex-col gap-2">
                <label className="">Password</label>
                <input
                  name="password"
                  required
                  data-testid="passInput"
                  className="bg-[#f8f8f8] font-normal border-[2.6px] border-[#efefef] placeholder:text-[#b4b4b4] placeholder:font-normal px-3.5 focus:outline-0 py-3 rounded-md"
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter your password"
                />
                <i
                  className={`absolute hover:scale-105 transition-transform duration-200  cursor-pointer right-6 top-[60%] fa-solid fa-eye${
                    !showPassword ? "-slash" : ""
                  }`}
                  onClick={() => setShowPassword(!showPassword)}
                ></i>
              </div>
            </div>

            {/* LOGIN Buttons */}

            <div className="flex flex-col w-3/5 items-center mx-auto mt-4 gap-3.5">
              <button
                // onClick={() => navigate("/k-8")}
                type="submit"
                className="bg-primary text-white px-14 py-2 rounded-md"
              >
                {isApiCall ? (
                  <>
                    Logging in...
                    <i className="fa-solid fa-spinner fa-spin ml-2"></i>
                  </>
                ) : (
                  "Login"
                )}
              </button>
              <Link
                to="/forgot-password"
                className="text-primary font-normal whitespace-nowrap cursor-pointer"
              >
                Forgot Password?
              </Link>
            </div>
          </form>
          <div className="grid grid-cols-5 w-full gap-1 items-center">
            <div className="col-span-2 h-[1px] bg-gray-200"></div>
            <div className="col-span-1 w-full justify-center flex">
              <span>OR</span>
            </div>

            <div className="col-span-2 h-[1px] bg-gray-200"></div>
          </div>
          <div>
            <Tooltip
              content={`This feature is under maintenance, and will be available soon`}
            >
              <Button
                className="m-auto bg-white text-gray-700 flex gap-1 w-full"
                onClick={handleGoogleAuthentication}
              >
                <img
                  src="/Images/google_icon.svg"
                  alt="Google Login"
                  width={24}
                  height={24}
                />
                Sign in with Google
              </Button>
            </Tooltip>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginRegisterScreen;
